import { jsx as _jsx } from "react/jsx-runtime";
import './TS_EditableItemControllerProto.scss';
import { asArray, BadImplementationException, deepClone, exists, resolveContent } from '@nu-art/ts-common';
import { EditableDBItemV3 } from '../../utils/EditableItem.js';
import { ProtoComponent } from '../../core/proto-component/index.js';
/**
 * Item_EditorController class handles the editing of a specific db item
 * and encapsulate logic to load the item from the local cache and uses the EditableItem to
 * and TS_EditableContent for rendering and editing the db item.
 *
 * @template Proto - The database prototype def to be edited
 * @template Props - The Props this class component takes
 */
export class TS_EditableItemControllerProto extends ProtoComponent {
    static DefaultAutoSave = (item) => {
        return !!item?._id;
    };
    constructor(p) {
        super(p);
        const method = p.module.defaultDispatcher.method;
        // @ts-ignore
        this[method] = this.__onItemUpdated;
    }
    __onItemUpdated = (...params) => {
        const itemId = this.state.editable.get('_id');
        if (!itemId)
            return;
        if (!(params[0] === 'update' && params[1]._id === itemId))
            return;
        this.state.editable?.setConflictingItem(deepClone(asArray(params[1]))[0]);
    };
    deriveStateFromProps(nextProps, state) {
        const _state = (state || {});
        const selectedId = this.getQueryParam('selected')?.[this.props.module.dbDef.dbKey];
        let item = typeof nextProps.item === 'string' ? nextProps.module.cache.unique(nextProps.item) : nextProps.item;
        if (!exists(item))
            item = nextProps.module.cache.unique(selectedId);
        if (!exists(item))
            item = this.props.createInitialInstance?.();
        if (!item)
            throw new BadImplementationException('in order to use this component to create an item you need to provide a createInitialInstance callback');
        _state.editable = new EditableDBItemV3(item, nextProps.module, nextProps.onError)
            .setOnChanged(async () => {
            this.forceUpdate();
        })
            .setAutoSave(resolveContent(nextProps.autoSave || TS_EditableItemControllerProto.DefaultAutoSave, item) || false);
        return _state;
    }
    render() {
        const Editor = this.props.editor;
        return _jsx(Editor, { editable: this.state.editable, ...(this.props.editorProps || {}) });
    }
}
//# sourceMappingURL=TS_EditableItemControllerProto.js.map